export const SUPPLIER_GET_LIST = 'SUPPLIER_GET_LIST';
export const BATCH_GET_LIST = 'BATCH_GET_LIST';
export const BATCH_ITEM_GET_LIST = 'BATCH_ITEM_GET_LIST';
export const BATCH_ITEM_LOGS_GET_LIST = 'BATCH_ITEM_LOGS_GET_LIST';
export const BATCH_SALE_GET_LIST = 'BATCH_SALE_GET_LIST';